<template>
  <div class="sm:px-4 lg:px-8">
    <div class="container flex flex-col space-y-4 pt-4 lg:space-y-6 lg:pt-6">
      <LegacyPageProfileTabs v-bind="tabs" />

      <NuxtPage />
    </div>
  </div>
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp();
const { locale, t: translate } = useI18n();
const mappedLocale = computed(() => reverseLocaleMap(locale.value));

const tabs = ref({
  tabs: {
    current: "",
    default: "latest",
    rootPath: `/${mappedLocale.value}/updates`,
    items: [
      { name: "Latest", slug: "latest" },
      { name: "Follows", slug: "follows" },
    ],
  },
});
</script>
